import { GetStaticPropsContext, GetStaticPropsResult } from 'next';
import Layout from '@/components/layouts/Layout';
import { Fragment } from 'react';

import { revalidateTimeout } from '@/lib/constants';
import { drupal } from '@/utils/drupal/drupal';
import { getGlobalElements } from '@/utils/drupal/get-global-elements';
import { getParams } from '@/utils/drupal/get-params';
import { DrupalNode } from 'next-drupal';
import { NodePageProps } from 'pages/[...slug]';
import { Paragraph } from '@/components/paragraph';
import { BlockRecipes } from '@/components/block-recipes';
import { getResourcePath } from '@/utils/drupal/get-resource-path';
import getContent from '@/utils/drupal/get-content';

export default function QuienesSomos({
  content,
  blocks,
  theme,
  preFooter,
  meta,
  canonical,
}: NodePageProps) {

  return (
    <Layout blocks={blocks} theme={theme ? 'dark' : 'light'} layoutType='base' preFooter={preFooter} meta={meta} canonical={canonical}>
      <div>

        {content.paragraphs.length ? content.paragraphs.map((item, index) => (
          <Fragment key={index}>
            {item.type == "paragraph--icon_slider" ?
              <>
                <Paragraph key={index} paragraph={item} />
                <BlockRecipes view={content.views.content} title="Navidul al día" />
              </>
              : <Paragraph key={index} paragraph={item} />}
          </Fragment>
        )) : null}
      </div>
    </Layout>
  );
};

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<NodePageProps>> {
  const path = await drupal.translatePath("/es/quienes-somos");
  const resource = await getResourcePath(path, context);
  if (resource == null) {
    return {
      notFound: true,
      revalidate: revalidateTimeout
    };

  }
  const type = path.jsonapi?.resourceName;
  const contentObject = await getContent(resource, type, context);

  const slug = "/es/quienes-somos";

  contentObject.content.views.content = await drupal.getResourceCollectionFromContext<DrupalNode[]>(
    "node--recipe", context, {
    params: getParams("node--recipe", "card")
      .addSort("created", "DESC")
      .addPageLimit(3)
      .getQueryObject(),
  });

  return {
    props: {
      ...(await getGlobalElements(context)),
      content: contentObject.content,
      meta: contentObject.content.node.metatag ? contentObject.content.node.metatag : null,
      theme: contentObject.content.node.field_dark_banner,
      preFooter: contentObject.content.node.field_show_prefooter,
      canonical: path.entity.path ? path.entity.path : slug,
    },
    revalidate: revalidateTimeout
  };
};
